import React from "react";
import { FaWhatsapp } from "react-icons/fa";
import "./contact-btn.css";

const ContactBtn = () => {
    return (
        <div className="app__contact-btn">
            <a className="d-flex flex-item-center" href="https://wa.me/+2347061326122" target="_blank" rel="noreferrer">
                <FaWhatsapp />
            </a>
        </div>
    )
}

export default ContactBtn;